import Box from '../../components/fela/Box';
import { FelaCSS } from '../../components/fela/flowtypes';
import { DroppedFile } from '../../components/file-uploader/types';

type Props = {
  dropped: DroppedFile;
  style: {
    fileUploadingImageWrap: FelaCSS;
    fileUploadingImage: FelaCSS;
  };
  uploadType?: 'photo' | 'file' | '*';
};

const PhotoPreview = ({ dropped, style, uploadType }: Props) => {
  if (uploadType === 'photo' && dropped.file) {
    return (
      <Box myattr="file-uploading-image-wrap" style={style.fileUploadingImageWrap}>
        <Box
          as="img"
          myattr="file-uploading-image"
          style={style.fileUploadingImage}
          // @ts-ignore
          src={dropped.file.preview}
          alt="preview"
        />
      </Box>
    );
  }
  return null;
};

export default PhotoPreview;
